import { Box, Typography } from "@mui/material";
import {
  timeBoxContainer,
  timeBoxDateText,
  timeBoxTitleText,
} from "./TimeBoxStyles";

interface TimeBoxContainerProps {
  title: string;
}

export const TimeBoxContainer = ({ title }: TimeBoxContainerProps) => {
  const todaysDate = new Date();
  const formattedDate = todaysDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
  return (
    <Box sx={timeBoxContainer}>
      <Typography sx={timeBoxDateText} component="span">
        {formattedDate}{" "}
      </Typography>
      <Typography sx={timeBoxTitleText} component="span">
        | {title}
      </Typography>
    </Box>
  );
};
